import { UpdatePasswordPage } from './update-password.component';
import { connect } from 'react-redux';
import { userUpdate } from './../../api/user/userAction';

const mapDispatchToProps = {
    userUpdate
};

const mapStateToProps = state => ({
    loggedUser: state.userPage.loggedUser
});

export const UpdatePasswordContainer = connect(mapStateToProps, mapDispatchToProps)(UpdatePasswordPage);